angular.module('vastdesk').
  component('frequencyCaps', {
    bindings: {},
    controller: ['$element', '$rootScope', '$compile', function($element, $rootScope, $compile) {

      var bodySelector = $('body');
      var frequencyCapsElement = $element.parents('#frequency_caps');

      var toggleTypeFields = function(add_form) {
        setTimeout(function() {
          var frequencyCapType = add_form.find('.frequency-cap-type input:checked').val();

          add_form.find('.fcap_metric').toggleClass('hidden', !['springserve', 'household'].includes(frequencyCapType));
          add_form.find('.fcap_third_party').toggleClass('hidden', frequencyCapType !== 'global');
          add_form.find('.allow-empty-household-id').toggleClass('hidden', frequencyCapType !== 'household');
          enableAllPeriods(add_form);

          if (frequencyCapType === 'global') {
            var globalFcapSelect = add_form.find('.global-fcap-selector');

            if (globalFcapSelected(globalFcapSelect.val())) {
              const tomselect = globalFcapSelect.get(0)?.tomselect;
              const selectedValue = tomselect?.getValue();
              const selectedOption = $(tomselect?.getItem(selectedValue));
              disableInvalidPeriods(add_form, selectedOption);
            }
          }

          if (frequencyCapType !== 'global') {
            if (add_form.find('.fcap_metric .btn-group label.active').length < 1) {
              add_form.find('.fcap_metric .btn-group label[for*=frequency_cap_metric_impressions]').click();
            }
          }
        }, 0);
      };

      bodySelector.on('cocoon:after-insert', '#frequency_caps', function(e, insertedItem) {
        $(insertedItem).find(".angularjs-compile").each((i, compileElement) => {
          $rootScope.$apply(() => {
            const scope = angular.element(compileElement).scope();
            $compile(compileElement)(scope);
          });
        });

        $.each(frequencyCapsElement.find('select[data-tom-select]'), function(index, select){
          $(select).defaultTomSelect();
          if ($(select).is('.global-fcap-selector')) {
            initGlobalFcapDropdown($(select))
          }
        });

        $.each(frequencyCapsElement.find('.chosen-select'), function(index, select) {
          $(select).defaultChosen();
        });
      });

      frequencyCapsElement.on('click', '.frequency-cap-type', function() {
        var add_form = $(this).closest('.add_form');
        toggleTypeFields(add_form);
      });

      const enableAllPeriods = function(add_form) {
        add_form.find('.fcap_periods .btn-group label').attr('disabled', false);
      };

      var disableInvalidPeriods = function(add_form, selectedOption) {
        add_form.find('.fcap_periods .btn-group label').filter(function() {
          const selectedOptionData = selectedOption.data('customData');
          return $(this).data('periodMinutes') > selectedOptionData?.frequency_cap_period_in_minutes;
        }).attr('disabled', true);
      };

      var globalFcapSelected = function(globalFcapId) {
        return globalFcapId && globalFcapId !== '';
      };

      const initGlobalFcapDropdown = (element) => {
        const tomselect = element.get(0).tomselect;
        tomselect.on('change', function() {
          const add_form = element.closest('.add_form');
          enableAllPeriods(add_form);

          const globalFcapPixelId = tomselect.getValue();
          if (globalFcapSelected(globalFcapPixelId)) {
            const selectedGlobalFcapPixelOption = $(tomselect.getItem(globalFcapPixelId));

            const customData = selectedGlobalFcapPixelOption.data("customData");
            const newPeriod = customData?.frequency_cap_period;
            const newPeriodAmount = customData?.frequency_cap_period_amount;

            add_form.find('.fcap_periods .btn-group label[for*=frequency_cap_period_' + newPeriod + ']').click();
            disableInvalidPeriods(add_form, selectedGlobalFcapPixelOption);
            add_form.find('input[id*=frequency_cap_period_amount]').val(newPeriodAmount);
          }
        });
      };

      this.$onInit = function () {
        $('.global-fcap-selector').each(function () {
          $(this).defaultTomSelect();
          initGlobalFcapDropdown($(this));
        });
      };
    }]
});
